<template>
  <div class="palestrantes" id="palestrantes">
    <div class="svgTopo">
      <b-container fluid>
        <h1 class="titulo">{{ $t("tituloPalestrante") }}</h1>
        <b-img :src="svgTitulo" class="svgTitulo"></b-img>
      </b-container>

      <b-container class="bv-example-row bv-example-row-flex-cols">
        <b-row align-v="center">
          <b-col
            md="3"
            sm="6"
            cols="6"
            v-for="(item, index) in palestrantes"
            :key="index"
          >
            <b-img
              :src="`${item.photo}`"
              class="img-palestrante"
              rounded="circle"
            />
            <strong>
              <p class="nome">{{ item.name }}</p>
            </strong>
            <strong>
              <p class="empresa">{{ item.institution }}</p>
            </strong>
          </b-col>
        </b-row>
      </b-container>

      <b-container fluid>
        <b-img :src="svgFinal" class="svgFinal"></b-img>
      </b-container>
    </div>
  </div>
</template>

<script>
import { listarPalestrantes } from "@/services/api/Palestrantes";
// import CardPalestrante from "@/components/CardPalestrante.vue";
export default {
  name: "Palestrantes",
  // components: {
  //   CardPalestrante,
  // },
  beforeCreate() {
    listarPalestrantes()
      .then(res => {
        console.log("palestrantes", res.data);
        this.palestrantes = res.data;
      })
      .catch(error => {
        console.error("Erro ao obter palestrantes", error.response);
      });
  },
  data() {
    return {
      palestrantes: [],
      svgTitulo: require("../assets/Palestrantes/linhaTitulo.svg"),
      mainProps: {
        blankColor: "#777",
        width: 150,
        height: 150,
        class: "m1"
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.palestrantes {
  background-image: url("~@/assets/Palestrantes/PNG.png");
  height: auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.svgTopo {
  background-image: url("~@/assets/Palestrantes/svgTopoWeb.svg");
  background-repeat: no-repeat;
  background-position: top left;
}

.nome {
  font-weight: bold;
  font-size: 1.2em;
  margin: 10px 0 0;
  color: #000000;
}

.empresa {
  font-size: 0.9em;
  margin: 0px;
  padding-bottom: 25px;
  font-weight: 400;
}

.img-palestrante {
  height: 180px;
  width: 180px;
  object-fit: cover;
}

.svgTitulo {
  width: 185px;
  top: 50%;
  left: 50%;
  margin-bottom: 75px;
  z-index: -99;
  margin-top: -7px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.titulo {
  padding-top: 100px;
  font-size: 1.6em;
  text-align: center;
  font-weight: 300;
  color: black;
}

@media only screen and (max-width: 1024px) {
  .img-palestrante {
    height: 150px;
    width: 150px;
    object-fit: cover;
  }
}
@media only screen and (max-width: 767px) {
  .palestrantes {
    background: url("~@/assets/Palestrantes/fundoMobile.png") no-repeat;
    background-size: 100% 100%;
    /* background-size: 100% auto; */
  }

  .svgTopo {
    background: url("~@/assets/Palestrantes/svgTopoMobile.svg") no-repeat;
  }

  .titulo {
    padding-top: 150px;
    font-size: 2em;
    text-align: center;
    font-weight: 300;
  }

  .svgTitulo {
    width: 230px;
    top: 50%;
    left: 50%;
    margin-bottom: 75px;
    z-index: -99;
    margin-top: -7px;
  }
}

@media only screen and (max-width: 414px) {
  .img-palestrante {
    height: 120px;
    width: 120px;
    object-fit: cover;
  }
}

@media only screen and (max-width: 270px) {
  .img-palestrante {
    height: 3rem;
    width: 3rem;
    object-fit: cover;
  }
}
</style>
